import React, { useCallback, useState } from "react";
import OltSelect from "../../../../components/OltSelect";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Step, StepLabel, Stepper, TextField } from "@mui/material";
import { useFormError } from "../../../../components/Datatable/FormErrorProvider";
import api from "../../../../services/api";
import { useNotify } from "../../../../components/Datatable/NotifyProvider";
import FreeOnuSelect from "../FreeOnuSelectDetail";
import { SearchRounded } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import LineSrvSelect from "../../../../components/LineSrvSelect";
import CustomTextField from "../../../../components/CustomTextField";
import ProvisioningProgressModal from "../../../../components/ProvisioningProgressModal";


function genTaskId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, "").slice(0, 8);
  return Math.random().toString(16).slice(2, 10);
}


export default function RemDetail() {
  const error = useFormError()
  const [taskId, setTaskId] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [result, setResult] = useState(null)
  const [searchOnu, setSearchOnu] = useState(false)


  const [waitOlt, setWaitOlt] = useState(true)


  const fetchRem = () => {
    error.setErrors([])
    const tid = genTaskId()
    setTaskId(tid)
    setResult(null)
    setModalOpen(true)
    const snap = { ...state }
    api.post(`provisioning/olt/rem/detail/?task_id=${tid}`, { ...state, roteada: state.roteada == 2 })
      .then(res => {
        if (res.data.error) {
          setResult({ ok: false, message: res.data.error })
          return
        }
        if (res.data.errors) {
          setModalOpen(false)
          error.setErrors(res.data.errors)
          return
        }

        setResult({
          ok: true,
          message: "ONU removida com sucesso",
          info: [
            { label: "SN", value: snap.sn },
            { label: "Placa", value: snap.board },
            { label: "Porta", value: snap.port },
          ],
        })
        setState({
          sn: "",
          olt: null,
          board: "",
          port: ""
        })
      }

      )
      .catch(e => {
        setResult({ ok: false, message: "Falha: " + (e?.message || e) })
      })
  }
  const [state, setState] = useState({
    sn: "",
    olt: null,
    board: "",
    port: ""
  })
  const notify = useNotify()


  const handleState = useCallback((event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  }, [state])


  return (
    <Box display={"flex"} flexWrap={'wrap'} flexDirection={"column"} justifyContent={"center"}
      sx={{
        width: { xs: "auto", sm: "auto", md: 400 }
      }}
      gap={1}
    >


      <OltSelect

        size="small"

        value={state.olt}
        handler={(e) => { setState({ ...state, olt: e }); setWaitOlt(true) }}
        admin={false}
      />
      <Box display={"flex"} flexDirection={{xs:"column",sm:"row", }} gap={1} >

        <CustomTextField
          size="small" 
          error={error.verify('board')}
          helperText={error.msgError('board')}
          label='Placa'
          value={state.board}
          name={'board'}
          onChange={handleState}
          type="number"
        />
        <CustomTextField
          size="small"
          error={error.verify('port')}
          helperText={error.msgError('port')}
          label='Porta'
          value={state.port}
          name={'port'}
          onChange={handleState}
          type="number"
        />
      </Box>

      <CustomTextField
        size="small"
        error={error.verify('sn')}
        helperText={error.msgError('sn')}
        label='SN'
        value={state.sn}
        name={'sn'}
        onChange={handleState}
        type="text"
      />
      <Box>
      </Box>
      <Button variant="contained"
        onClick={fetchRem}>{"Remover"}</Button>

      <ProvisioningProgressModal
        open={modalOpen}
        taskId={taskId}
        mode="user"
        streamPath="/provisioning/stream"
        result={result}
        onClose={() => { setModalOpen(false); setResult(null) }}
      />
    </Box >
  )
}